import { motion } from "framer-motion";

const BingLoader = () => {
    return (
        <div className="relative w-3 h-3">
            {/* Pulsing ring */}
            <motion.div
                className="absolute top-0 left-0 w-3 h-3 rounded-full bg-red-500"
                initial={{ scale: 1, opacity: 1 }}
                animate={{
                    scale: [1, 2],
                    opacity: [1, 0],
                }}
                transition={{
                    duration: 1,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
            />

            {/* Static center dot */}
            <div className="absolute top-0 left-0 w-3 h-3 rounded-full bg-red-500 z-10" />
        </div>
    );
};

export default BingLoader;
